// copllapsible scroll in product page
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.collapsiblescroll').forEach(function (el) {
  el.addEventListener('click', function () {
    var sectionId = el.getAttribute('scrolling-section-id');
    if (!sectionId) return;
    // custom-scroll attribute thi element find
    var targetSection = document.querySelector(
      '[data-custom-scroll="' + sectionId + '"]'
    );

    if (targetSection) {
      targetSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

  });
});

});
